import cx from 'classnames';
import Image from 'next/image';

import {Text} from '#component/base';
import {anchorNames} from '#component/page/HealthFactorAssessment/HealthFactorAssessment.util';
import {EventType, useAnalytics, UserActionEvent} from '#component/provider/AnalyticsProvider';

import * as css from './HealthFactorScience.css';

export const HealthFactorScience = ({
  title,
  description,
  url,
  thumbnailUrl,
}: {
  url?: string;
  thumbnailUrl?: string;
  title: string;
  description: string;
}) => {
  const {track} = useAnalytics();
  const handleCTAClick = () => {
    track<UserActionEvent>({
      evtName: EventType.UserAction,
      actionName: 'View science content',
      data: {contentSlug: url},
    });
  };

  const titleSection = (
    <>
      <Text variant="label" color="orange" className={css.label}>
        The Science
      </Text>
      <Text variant="heading2" as="h2" color="burgundy" className={css.title}>
        {title}
      </Text>
    </>
  );

  const hasThumbnail = !!(url && thumbnailUrl);
  return (
    <div className={css.root} id={anchorNames.science}>
      {hasThumbnail ? (
        <a
          onClick={handleCTAClick}
          href={url}
          target="_blank"
          rel="noreferrer"
          className={css.imageLink}
          aria-label="Research Information">
          <Image src={thumbnailUrl} layout="fill" objectFit="cover" alt="Research Information" />
        </a>
      ) : (
        <div className={css.titleSectionWithoutThumbnail}>{titleSection}</div>
      )}
      <div className={cx(css.info, {[css.infoSectionWithoutThumbnail]: !hasThumbnail})}>
        {hasThumbnail && titleSection}
        <Text variant="bodyLarge" color="doveGray">
          {description}
        </Text>
      </div>
    </div>
  );
};
